import React from 'react';

export function Sheet () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_19000_12503)"
      >
        <path d="M25 25a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2h9.586a1 1 0 01.707.293l9.414 9.414a1 1 0 01.293.707V25zM9 9h4M9 15h10M9 21h10" />
      </g>
      <defs>
        <clipPath id="clip0_19000_12503">
          <path fill="#fff" d="M0 0H28V28H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
